/**
 * 産廃回収からの受注登録 仮保存
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../../constants/httpConst'
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections/registrations`
const orders_accepts_collection_registration_provisional = {
  namespaced: true,
  actions: {

    /**
     * 仮保存 更新登録
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/provisionals`
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}
export default orders_accepts_collection_registration_provisional
